import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ScrollToTop from "@/components/ScrollToTop";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import StoreLayout from "@/components/StoreLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import ProductDetail from "@/pages/ProductDetail";
import EquipmentDetail from "@/pages/EquipmentDetail";
import PutterSubcategory from "@/pages/PutterSubcategory";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import Contact from "@/pages/Contact";
import Technology from "@/pages/Technology";
import Dealers from "@/pages/Dealers";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminProductForm from "@/pages/admin/AdminProductForm";
import AdminBanners from "@/pages/admin/AdminBanners";
import AdminCategoryBanners from "@/pages/admin/AdminCategoryBanners";
import AdminPutterSubcategories from "@/pages/admin/AdminPutterSubcategories";
import AdminContent from "@/pages/admin/AdminContent";
import AdminStudios from "@/pages/admin/AdminStudios";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminAccount from "@/pages/admin/AdminAccount";

function App() {
  return (
    <div className="App">
      {/* Global SVG filter definitions — knock out near-white pixels
          from product photography so the black card background shows
          through. Zero DOM cost; applied via `.knockout-white` class. */}
      <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true" focusable="false">
        <defs>
          <filter id="pingKnockoutWhite" colorInterpolationFilters="sRGB">
            {/* alpha_new = -5R -5G -5B + 15A + 0
                → pure white (1,1,1,1) → 0 (transparent)
                → very light grey (>=0.93) → partial transparency
                → everything else → fully opaque, colours untouched */}
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0
                      0 1 0 0 0
                      0 0 1 0 0
                      -5 -5 -5 15 0"
            />
          </filter>
        </defs>
      </svg>
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <ScrollToTop />
            <AnalyticsTracker />
            <Routes>
              {/* Storefront */}
              <Route element={<StoreLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Catalog group="shop" />} />
                <Route path="/shop/:category" element={<Catalog group="shop" />} />
                <Route path="/product/:slug" element={<ProductDetail />} />
                <Route path="/equipment" element={<Catalog group="equipment" />} />
                <Route path="/equipment/product/:slug" element={<EquipmentDetail />} />
                <Route path="/equipment/putters/:subSlug" element={<PutterSubcategory />} />
                <Route path="/equipment/:category" element={<Catalog group="equipment" />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/order/:orderId" element={<OrderSuccess />} />
                <Route path="/technology" element={<Technology />} />
                <Route path="/dealers" element={<Dealers />} />
                <Route path="/contact" element={<Contact />} />
              </Route>

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminProducts />} />
                <Route path="products" element={<AdminProducts />} />
                <Route path="products/new" element={<AdminProductForm />} />
                <Route path="products/:id" element={<AdminProductForm />} />
                <Route path="banners" element={<AdminBanners />} />
                <Route path="category-banners" element={<AdminCategoryBanners />} />
                <Route path="putter-subcategories" element={<AdminPutterSubcategories />} />
                <Route path="content" element={<AdminContent />} />
                <Route path="studios" element={<AdminStudios />} />
                <Route path="orders" element={<AdminOrders />} />
                <Route path="enquiries" element={<AdminEnquiries />} />
                <Route path="account" element={<AdminAccount />} />
              </Route>
            </Routes>
            <Toaster position="top-right" />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
